import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const rolePermissionDetailsApi = createAsyncThunk(
    'auth/rolePermissions/detail',
    async (data, { rejectWithValue }) => {
        try {
            const { ID } = data
            const response = await AuthAxios.get(apiRoutes.adminAction(`roles_permissions/roles/${ID}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "", total: 0 }
const rolePermissionDetailsSlice = createSlice({
    name: 'rolePermission detail',
    initialState: intialState,
    reducers: {
        resetRolePermission: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(rolePermissionDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(rolePermissionDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload
            state.message = action?.payload?.message
        })
        builder.addCase(rolePermissionDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetRolePermission } = rolePermissionDetailsSlice.actions;
export const rolePermissionDetailsReducer = rolePermissionDetailsSlice.reducer